<svelte:options runes={true} />
<script lang="ts">import { onMount } from "svelte";
import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk';
let { siteKey, solution = $bindable(''), language = 'en' } = $props();
let friendlyContainer;
let widget;
onMount(() => {
    const sdk = new FriendlyCaptchaSDK();
    widget = sdk.createWidget({
        element: friendlyContainer,
        sitekey: siteKey,
        startMode: "focus",
        language: language,
    });
    // V2 uses event listeners instead of callbacks
    widget.addEventListener("frc:widget.complete", (event) => {
        solution = event.detail.response;
    });
    widget.addEventListener("frc:widget.error", (event) => {
        console.error("Friendly Captcha error:", event.detail);
    });
    return () => {
        if (widget && typeof widget.destroy === 'function') {
            widget.destroy();
        }
    };
});
</script>

<div
  bind:this={friendlyContainer}
  class="frc-captcha"
  data-sitekey={siteKey}
  data-lang={language}
></div>

<style lang="scss">.frc-captcha {
  box-sizing: border-box;
  min-width: 270px;
  height: 60px;
  border-radius: 3px;
  border: none;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
  background: #ffffff;
}</style>
